import { FC } from 'react'
import * as styles from 'styles/molecules/CommonFooter.css'
import { SUPPORT_EMAIL } from 'constants/email'
import Icon from 'components/atoms/Icon'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { EmailLink } from 'components/features/pfm/EmailLink/EmailLink'
import cn from 'classnames'

type CommonFooterProps = {
  className?: string
}

const CommonFooter: FC<CommonFooterProps> = ({ className }) => (
  <footer className={ cn(styles.footer, className) }>
    <div className={ styles.linkWrapper }>
      <span className={ styles.link }>
        <EmailLink email={ SUPPORT_EMAIL }>
          Need Help?
        </EmailLink>
      </span>
    </div>
    <div className={ styles.linkWrapper }>
      <NavigationLink to='security' className={ styles.link }>
        <span className={ styles.securityIconWrapper }>
          <Icon kind='secure' />
        </span>
        Your security is important to us.
      </NavigationLink>
    </div>
  </footer>
)

export default CommonFooter
